export function truncate(text: string | undefined, maxLength: number): string {
  if (!text) {
    return '';
  }

  if (text.length <= maxLength) {
    return text;
  }

  return `${text.substring(0, maxLength)}...`;
}

export function truncateAtSubstring(text: string | undefined, findText: string): string {
  if (!text) {
    return '';
  }

  const index = text.indexOf(findText);
  if (index === -1) {
    return text;
  }

  return text.substring(0, index);
}
